
		import { defineComponent, reactive } from 'vue'
		const CHARS = 'abcdefghjklmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789'
		const COLORS = ['#0f172a', '#375d7e', '#874c1f', '#6b21a8', '#166534', '#dc2626']

		export default defineComponent({
				name: 'CaptchaCanvas',
				props: {
						width: { type: Number, default: 200 },
						height: { type: Number, default: 60 },
						length: { type: Number, default: 5 }

				},				
				data() {
						return {
								userInput: '' as string,
								status: null as 'success' | 'error' | null,
								currentCode: '' as string
						}
				},
				methods: {
						randomChar(): string {
								return CHARS[Math.floor(Math.random() * CHARS.length)]
						},
						generate(): void {
								const canvas = this.$refs.canvasRef as HTMLCanvasElement | undefined
								if (!canvas) return
								const ctx = canvas.getContext('2d')
								if (!ctx) return

								// Generar código
								this.currentCode = Array.from({ length: this.length }, () => this.randomChar()).join('')
								this.userInput = ''
								this.status = null

								// Fondo
								ctx.clearRect(0, 0, this.width, this.height)
								ctx.fillStyle = '#f4f4f2'
								ctx.fillRect(0, 0, this.width, this.height)

								// Líneas de ruido
								for (let i = 0; i < 5; i++) {
										ctx.strokeStyle = `hsl(${Math.random() * 360}, 40%, 70%)`
										ctx.lineWidth = 1
										ctx.beginPath()
										ctx.moveTo(Math.random() * this.width, Math.random() * this.height)
										ctx.lineTo(Math.random() * this.width, Math.random() * this.height)
										ctx.stroke()
								}

								// Puntos de ruido
								for (let i = 0; i < 60; i++) {
										ctx.fillStyle = `hsl(${Math.random() * 360}, 30%, 60%)`
										ctx.beginPath()
										ctx.arc(Math.random() * this.width, Math.random() * this.height, 1, 0, Math.PI * 2)
										ctx.fill()
								}

								// Caracteres distorsionados
								const charWidth = this.width / (this.length + 1)
								this.currentCode.split('').forEach((char: string, i: number) => {
										ctx.save()
										ctx.font = `bold ${28 + Math.floor(Math.random() * 8)}px monospace`
										ctx.fillStyle = COLORS[i % COLORS.length]
										const x = charWidth * (i + 0.6)
										const y = this.height * 0.7 + (Math.random() * 8 - 4)
										ctx.translate(x, y)
										ctx.rotate((Math.random() - 0.5) * 0.45)
										ctx.fillText(char, 0, 0)
										ctx.restore()
								})
						},
						verify(): boolean {
								//const isValid = (this.userInput || '').trim().toUpperCase() === this.currentCode
								const isValid = (this.userInput || '').trim() === this.currentCode
								this.status = isValid ? 'success' : 'error'
								this.$emit('verified', isValid)
								//	console.log('Verificando:', { input: this.userInput, code: this.currentCode, isValid })
								if (!isValid) { this.generate() }
								return isValid

							
						}
						,
						getCurrentCode(): string {
								return this.currentCode
						},
						getUserInput(): string {
								return this.userInput
						},
						resetUserInput(): void {
								this.userInput = ''
								this.status = null
						}
				},
				mounted() {
						this.generate()
				}
		})
